import { render, staticRenderFns } from "./FinalizarTicket.vue?vue&type=template&id=5bb55e61"
import script from "./FinalizarTicket.vue?vue&type=script&lang=js"
export * from "./FinalizarTicket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports